
const aboutincredfin = {
    "About InCred Financial": [
        {
          question: "What is the business of InCred Financial Services Limited (IFSL)?",
          answer: "InCred Financial Services Limited is a Non-Banking Financial Corporation having segments such as Personal Loan, Student Loan, School Financing & LAP, Anchor & Escrow backed lending & Lending to Financial Institutions."
        },
        {
          question: "Who are the promoters of IFSL?",
          answer: "IFSL was founded by Mr. Bhupinder Singh (Founder & Group CEO) and is backed by marquee investors like KKR Singapore, Teacher’s retirement of Texas, Abu Dhabi Investment Authority, Moore Strategic Ventures and more."
        },
        {
          question: "Is IFSL Rated?",
          answer: "InCred Finance has a long-term rating of A+ by CRISIL & CARE with a stable Outlook."
        },
        {
          question: "What is the AUM of IFSL?",
          answer: "The AUM at the end of FY23 of IFSL is Rs. 6,062 crores with the following split:" + "<br/>" +
          "Personal Loans: Rs. 2,550 Crs."+ "<br/>" +
          "Student Loans: Rs. 1,038 Crs."+ "<br/>" +
          "School Financing & LAP: Rs. 486 Crs."+ "<br/>" +
          "Anchor & Escrow backed lending: Rs. 1,255 Crs."+ "<br/>" +
          "Lending to Financial Institutions: Rs. 608 Crs."+ "<br/>" +
          "Wholesale lending: 124 Crs."
        },
        {
          question: "What is the % of Secured and Unsecured lending?",
          answer: "The secured book of IFSL stands at 40% and unsecured at 60%."
        },
        {
          question: "What is the profitability of IFSL?",
          answer: "IFSL has been profitable since the first year of operation in 2017. For FY23, the PAT stands at Rs. 120 Crs."
        },
        {
          question: "What is the extent of Bad loans (NPAs) of IFSL?",
          answer: "The NPAs of IFSL as on FY23 are relatively low. GNPA: 2.1% NNPA : 0.9%"
        },
        {
          question: "How leveraged is IFSL? / What is the debt to equity Ratio of IFSL?",
          answer: "IFSL is leveraged 1.6 times."
        },
        {
          question: "What is the Net Interest margin of IFSL?",
          answer: "IFSL operates at a healthy NIM of 9.6%."
        },
        {
          question: "What is the Capital Adequacy ratio?",
          answer: "As of March 2023, The CRAR is 33.4%."
        },
    ],
  }
  
  export default aboutincredfin;